export const check = (obj = {}, targetArgsCount) => {
    return {
        calc: Object.keys(obj).length >= targetArgsCount && Object.values(obj).filter(el => el === undefined).length === 0,
        reset: Object.keys(obj).length > 0
    };
}
